


import React, { useEffect, useRef, useState } from "react";
import { GoogleMap, Marker, StandaloneSearchBox, DirectionsRenderer, LoadScript } from "@react-google-maps/api";
import { setLatLng } from "../redux/addressSlice";
import ApiBaseURLProps from "../components/other/apiBaseURL";

const apiKey = ApiBaseURLProps.mapApiKey; // API key
const libraries = ["places"]; // required libraries for Google Maps
const MapComponent = ({ dispatch, LatLng, onChange, isAdmin }) => {
    // const dispatch = useDispatch(); // Use hook directly since it's not passed as prop
    const searchBoxRef = useRef(null);
    const mapRef = useRef(null);


    const defaultLocation = { lat: 27.7172, lng: 85.324 }; // Default fallback location
    const [directions, setDirections] = useState(null);
    const [mapState, setMapState] = useState({
        mapPosition: defaultLocation,
        markerPosition: defaultLocation,
    });


    const changeLocation = (data) => {
        if (dispatch)
            dispatch(setLatLng(data));
        else
            onChange(data);
    }
    // Get current location
    const goToCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const newLocation = {
                        mapPosition: { lat: latitude, lng: longitude },
                        markerPosition: { lat: latitude, lng: longitude },
                    };
                    setMapState(newLocation);
                    changeLocation(newLocation);
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    alert(
                        error.code === error.PERMISSION_DENIED
                            ? "Please enable location permissions in your browser."
                            : `Error fetching location: ${error.message}`
                    );
                    // Fallback to default location
                    setMapState({
                        mapPosition: defaultLocation,
                        markerPosition: defaultLocation,
                    });

                    changeLocation({
                        mapPosition: defaultLocation,
                        markerPosition: defaultLocation,
                    });
                    // if (dispatch)
                    //     dispatch(setLatLng({
                    //         mapPosition: defaultLocation,
                    //         markerPosition: defaultLocation,
                    //     }));
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
            setMapState({
                mapPosition: defaultLocation,
                markerPosition: defaultLocation,
            });

            changeLocation({
                mapPosition: defaultLocation,
                markerPosition: defaultLocation,
            });
            // if (dispatch)
            //     dispatch(setLatLng({
            //         mapPosition: defaultLocation,
            //         markerPosition: defaultLocation,
            //     }));
        }
    };

    // Sync with Redux state or initialize with current location
    useEffect(() => {
        if (LatLng == undefined) return;
        if (LatLng?.markerPosition?.lat && LatLng?.markerPosition?.lng) {
            setMapState(LatLng);
        } else {
            if (isAdmin) return;
            goToCurrentLocation();
        }
    }, [LatLng]);
    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .gm-style .gm-style-cc, .gm-style-cc span {
                display: none !important;
            }
        `;
        document.head.appendChild(style);
    }, []);
    // Handle map load
    const onMapLoad = (map) => {
        mapRef.current = map;
        changeDirection(defaultLocation, defaultLocation); // Initialize directions
    };

    // Handle search box load
    const onSBLoad = (ref) => {
        searchBoxRef.current = ref;
    };

    // Handle place selection
    const onPlacesChanged = () => {
        if (searchBoxRef.current) {
            const places = searchBoxRef.current.getPlaces();
            if (places?.length > 0) {
                const place = places[0];
                const newLocation = {
                    mapPosition: {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    },
                    markerPosition: {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    },
                };
                setMapState(newLocation);

                changeLocation(newLocation);
                changeDirection(newLocation.markerPosition, newLocation.markerPosition);
            }
        }
    };

    // Update directions
    const changeDirection = (origin, destination) => {
        if (!window.google?.maps) return;
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin,
                destination,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === directionsService.OK) {
                    console.log("akak111", directionsService.OK);
                    setDirections(result);
                } else {
                    console.error("Error fetching directions:", status, result);
                    setDirections(null); // Clear directions on error
                }
            }
        );
    };

    // Handle marker drag end
    const onMarkerDragEnd = (event) => {
        const newLocation = {
            mapPosition: { lat: event.latLng.lat(), lng: event.latLng.lng() },
            markerPosition: { lat: event.latLng.lat(), lng: event.latLng.lng() },
        };
        setMapState(newLocation);
        changeLocation(newLocation);
        // if (dispatch)
        //     dispatch(setLatLng(newLocation));
        changeDirection(newLocation.markerPosition, newLocation.markerPosition);
    };

    // Handle map click
    const onMapClick = (event) => {
        const newLocation = {
            mapPosition: { lat: event.latLng.lat(), lng: event.latLng.lng() },
            markerPosition: { lat: event.latLng.lat(), lng: event.latLng.lng() },
        };
        setMapState(newLocation);

        changeLocation(newLocation);
        // if (dispatch)
        //     dispatch(setLatLng(newLocation));
        changeDirection(newLocation.markerPosition, newLocation.markerPosition);
    };

    return (
        <>

            <LoadScript googleMapsApiKey={apiKey} libraries={libraries}
                onError={(e) => console.error("LoadScript error:", e)}>
                <GoogleMap
                    center={mapState.markerPosition}
                    zoom={15}
                    onLoad={onMapLoad}
                    onClick={onMapClick}
                    mapContainerStyle={{ height: "400px", width: "100%" }}
                >
                    <StandaloneSearchBox onLoad={onSBLoad} onPlacesChanged={onPlacesChanged}>
                        <input
                            type="text"
                            placeholder="Search for places"
                            style={{
                                boxSizing: "border-box",
                                border: "1px solid transparent",
                                width: "240px",
                                height: "32px",
                                padding: "0 12px",
                                borderRadius: "3px",
                                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
                                fontSize: "14px",
                                outline: "none",
                                textOverflow: "ellipses",
                                position: "absolute",
                                top: "10px",
                                left: "50%",
                                marginLeft: "-120px",
                            }}
                        />
                    </StandaloneSearchBox>
                    <Marker
                        position={mapState.markerPosition}
                        draggable={true}
                        onDragEnd={onMarkerDragEnd}
                    />
                    {directions && <DirectionsRenderer directions={directions} />}
                </GoogleMap>
            </LoadScript>
        </>
    );
};

export default MapComponent;